<style scoped>

</style>
<template>
  <span>{{ name }}</span>
</template>
<script>
  import {mapGetters} from "vuex";

  export default {
    props: {
      id: {
        type: Number,
        required: true
      }
    },
    computed: {
      ...mapGetters('async', ['jobs_hash']),
      name() {
        if (!this.id) return '未设置';
        const job = this.jobs_hash[this.id];
        return job ? job.name : '未找到';
      }
    },
  }
</script>
